import { format, isValid, parse } from "date-fns";

export const formatTimeLabel = (value?: string): string | null => {
  if (!value) {
    return null;
  }

  const parsed = parse(value, "HH:mm:ss", new Date());
  if (!isValid(parsed)) {
    return null;
  }

  return format(parsed, "h aaa");
};
